import { useState } from 'react';
import { ChevronRight, Wrench, CheckCircle2, AlertTriangle, Loader2 } from 'lucide-react';

interface ToolCallBubbleProps {
  name: string;
  input?: Record<string, unknown>;
  ok?: boolean;
  error?: string;
  ms?: number;
}

export function ToolCallBubble({ name, input, ok, error, ms }: ToolCallBubbleProps) {
  const [open, setOpen] = useState(false);
  const pending = ok === undefined;
  const icon = pending
    ? <Loader2 className="h-3 w-3 animate-spin text-brand-400" />
    : ok
      ? <CheckCircle2 className="h-3 w-3 text-emerald-400" />
      : <AlertTriangle className="h-3 w-3 text-amber-400" />;

  return (
    <div className="mt-1 max-w-md rounded-lg border border-white/10 bg-white/[0.03] text-[11px]">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex w-full items-center gap-1.5 px-2 py-1 font-mono text-neutral-300 transition hover:bg-white/5"
      >
        <ChevronRight className={`h-3 w-3 text-neutral-500 transition ${open ? 'rotate-90' : ''}`} />
        <Wrench className="h-3 w-3 text-brand-400" />
        <span className="font-semibold">{name}</span>
        {ms !== undefined && <span className="text-neutral-500">· {ms}ms</span>}
        <span className="ml-auto">{icon}</span>
      </button>
      {open && (
        <div className="border-t border-white/5 px-2 py-1.5 font-mono text-[10px] text-neutral-400">
          {input && (
            <div>
              <span className="text-neutral-500">input:</span>{' '}
              <span className="break-all">{JSON.stringify(input)}</span>
            </div>
          )}
          {error && (
            <div className="mt-1 text-amber-300">
              <span className="text-amber-400/60">error:</span> {error}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
